import * as React from "react";
const SvgKitchen = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath="url(#Kitchen_svg__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 1.85c-.676 0-1.25.567-1.25 1.278V7.35h20.5V3.128c0-.711-.574-1.278-1.25-1.278H3ZM1.75 21.072V8.85h20.5v12.19c-.082.85-.687 1.31-1.25 1.31H3c-.676 0-1.25-.567-1.25-1.278ZM.25 3.128C.25 1.608 1.476.35 3 .35h18c1.524 0 2.75 1.258 2.75 2.778V21.103l-.003.03C23.62 22.699 22.431 23.85 21 23.85H3c-1.524 0-2.75-1.258-2.75-2.778V3.128Zm4.5 9.232c0-.2.181-.51.724-.51H7.25v1.125c0 .386.177.72.39.946.213.223.546.429.953.429h6.814c.407 0 .74-.206.952-.43.214-.225.391-.559.391-.945V11.85h1.776c.543 0 .724.31.724.51v6.48c0 .088-.043.204-.184.318a.883.883 0 0 1-.54.192H5.474c-.543 0-.724-.31-.724-.51v-6.48Zm4 .49v-1h6.5v1h-6.5Zm-3.276-2.5c-1.142 0-2.224.77-2.224 2.01v6.48c0 1.24 1.082 2.01 2.224 2.01h13.052c.544 0 1.079-.196 1.487-.528.412-.336.737-.85.737-1.482v-6.48c0-1.24-1.082-2.01-2.224-2.01H5.474ZM6.05 4.6a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm5.8 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-2 .5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7.3 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="Kitchen_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKitchen;
